/**
 * Версия Условий использования (ToS) / согласия.
 *
 * ⚠️ ЗЕРКАЛО backend-константы:
 * Backend/src/shared/constants/terms.constants.ts → CURRENT_TERMS_OF_SERVICE_VERSION.
 *
 * Форма регистрации отправляет это значение в поле `acceptedTermsVersion`; backend строго
 * сверяет его (`@Equals`, GDPR Art. 7 — доказуемое согласие) и отклоняет регистрацию (400),
 * если версия не совпадает или отсутствует.
 *
 * При изменении Условий — бампить СИНХРОННО с backend-константой, иначе регистрация сломается.
 */
export const CURRENT_TERMS_OF_SERVICE_VERSION = "1.0";
